export const visit = (vm, at) => {
at({ "en": { "pricing-page-components": { "phone-support": { "seePhoneNumber": "See phone number" } } } });
};